import { ApolloClient, createHttpLink, DefaultOptions, InMemoryCache } from "@apollo/client/core";
import { setContext } from "@apollo/client/link/context";
import { CHARGE_SERVICE } from "../appConfig";

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore"
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all"
  }
};

const cache = new InMemoryCache();

const httpLink = createHttpLink({
  uri: CHARGE_SERVICE
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("user-token");
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : ""
    }
  };
});

export default new ApolloClient({
  cache,
  link: authLink.concat(httpLink),
  defaultOptions
});
